import { defineStore } from 'pinia'

import * as interiorApi from '../services/api/interior'
import { IApproval } from './staff'

export interface IInteriorData {
  id: number
  status: string
  note: string
  reason: string
  approvals: Array<IApproval>
  date_in: string
  date_out: string
  works: Array<Record<string, never>>
  assignee_id: number
  creator_id: any
  car: any
  created_at: string
}

export const useInteriorStore = defineStore('interior', {
  state: () => ({
    interior: {
      id: 0,
      status: '',
      note: '',
      reason: '',
      approvals: [],
      date_in: '',
      date_out: '',
      works: [],
      assignee_id: 0,
      creator_id: 0,
      car: null,
      created_at: '',
    } as IInteriorData,
    isLoading: false,
  }),

  actions: {
    setInterior(data: IInteriorData) {
      this.interior = data
    },

    setLoading(value: boolean) {
      this.isLoading = value
    },

    async getInterior(interior_id: number) {
      try {
        this.setLoading(true)
        const { data } = await interiorApi.get(interior_id)
        this.setInterior(data)
        this.setLoading(false)
      } catch (e) {
        this.setLoading(false)
        throw new Error(String(e))
      }
    },

    async updateInterior(payload: any) {
      try {
        this.setLoading(true)
        const { data } = await interiorApi.update(this.interior.id, payload)
        this.setInterior(data)
        this.setLoading(false)
      } catch (e) {
        this.setLoading(false)
        throw new Error(String(e))
      }
    },

    async rejectInterior(payload: any) {
      try {
        this.setLoading(true)
        const { data } = await interiorApi.reject(this.interior.id, payload)
        this.setInterior(data)
        this.setLoading(false)
      } catch (e) {
        this.setLoading(false)
        throw new Error(String(e))
      }
    },

    async remakeInterior(payload: any) {
      try {
        this.setLoading(true)
        const { data } = await interiorApi.remake(this.interior.id, payload)
        this.setInterior(data)
        this.setLoading(false)
      } catch (e) {
        this.setLoading(false)
        throw new Error(String(e))
      }
    },

    async approveInterior(params: any) {
      try {
        this.setLoading(true)
        const { data } = await interiorApi.approve(this.interior.id, params)
        this.setInterior(data)
        this.setLoading(false)
      } catch (e) {
        this.setLoading(false)
        throw new Error(String(e))
      }
    },
  },
})

export const useInteriorListStore = defineStore('interiorList', {
  state: () => ({
    interiors: [] as IInteriorData[],
    count: 0,
    isLoading: false,
    total: 0,
  }),

  actions: {
    setCount(data: number) {
      this.count = data
    },

    setInteriors(data: IInteriorData[]) {
      this.interiors = data
    },

    setLoading(value: boolean) {
      this.isLoading = value
    },

    setTotal(value: number) {
      this.total = value
    },

    async countInteriors() {
      try {
        this.setLoading(true)
        const { data } = await interiorApi.count()
        this.setCount(data)
        this.setLoading(false)
      } catch (e) {
        this.setLoading(false)
        throw new Error(String(e))
      }
    },

    async listInteriors(params: any) {
      try {
        this.setLoading(true)
        const { data } = await interiorApi.list(params)
        this.setInteriors(data)
        this.setLoading(false)
      } catch (e) {
        this.setLoading(false)
        throw new Error(String(e))
      }
    },

    async listAllInteriors(params: any) {
      try {
        this.setLoading(true)
        const result = await interiorApi.listAllInterior(params)
        const { data, total } = result as any
        this.setInteriors(data)
        this.setTotal(total)
        this.setLoading(false)
        return result
      } catch (e) {
        this.setLoading(false)
        throw new Error(String(e))
      }
    },
  },
})
